import { useDispatch } from "react-redux";
import { capitalize } from "lodash";
import dayjs from "@shared/dayjs";

import { CalendarRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import PipedElements from "../PipedElements";
import CategoryContainer from "./CategoryContainer";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import DataField from "./DataField";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";
import Thumbnail from "./shared/Thumbnail";

const ShowingRequestActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";

  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={CalendarRegularV6}>
            Showing Request
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={STYLES.contentContainer2}>
        <div className={`${STYLES.contentContainer} tw-text-14d`}>
          <DataField label="Address" data={activity.data?.propertyStreetAddress} />
          <DataField label="Comment" data={activity.data?.comment} />

          <PipedElements>
            <DataField
              label="Date"
              data={
                activity.data?.showingDateIso
                  ? dayjs(activity.data?.showingDateIso).format("MM/DD/YYYY")
                  : activity.data?.showingDate.replace(/^[^,]+, /, "")
              }
            />
            <DataField label="Time" data={capitalize(activity.data?.showingTime)} />
          </PipedElements>
          <ActivityBtns
            callHandlr={() => {
              if (activity.personUuid) {
                dispatch(
                  setCallParams({ leadUuids: [activity.personUuid], callSource: "Showing Request Activity" }),
                );
              }
            }}
            listingHandlr={
              activity.data?.propertyDetailsUrl
                ? () => {
                    window.open(activity.data?.propertyDetailsUrl, "_blank");
                  }
                : null
            }
          />
        </div>
        {activity.data.propertyMainPhoto && <Thumbnail src={activity.data.propertyMainPhoto} />}
      </div>
    </ActivityContainer>
  );
};

export default ShowingRequestActivity;

ShowingRequestActivity.propTypes = {
  ...activityCommonPropTypes,
};

ShowingRequestActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
